// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * WL.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { StudentLessonWritingByActivityRepresentation } from './StudentLessonWritingByActivityRepresentation'
import {
  StudentLessonWritingByActivityRepresentationFromJSON,
  StudentLessonWritingByActivityRepresentationFromJSONTyped,
  StudentLessonWritingByActivityRepresentationToJSON,
} from './StudentLessonWritingByActivityRepresentation'

/**
 *
 * @export
 * @interface StudentLessonWritingByActivityRepresentationBaseApiResult
 */
export interface StudentLessonWritingByActivityRepresentationBaseApiResult {
  /**
   *
   * @type {StudentLessonWritingByActivityRepresentation}
   * @memberof StudentLessonWritingByActivityRepresentationBaseApiResult
   */
  data?: StudentLessonWritingByActivityRepresentation
}

/**
 * Check if a given object implements the StudentLessonWritingByActivityRepresentationBaseApiResult interface.
 */
export function instanceOfStudentLessonWritingByActivityRepresentationBaseApiResult(
  value: object,
): boolean {
  let isInstance = true

  return isInstance
}

export function StudentLessonWritingByActivityRepresentationBaseApiResultFromJSON(
  json: any,
): StudentLessonWritingByActivityRepresentationBaseApiResult {
  return StudentLessonWritingByActivityRepresentationBaseApiResultFromJSONTyped(
    json,
    false,
  )
}

export function StudentLessonWritingByActivityRepresentationBaseApiResultFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): StudentLessonWritingByActivityRepresentationBaseApiResult {
  if (json === undefined || json === null) {
    return json
  }
  return {
    data: !exists(json, 'data')
      ? undefined
      : StudentLessonWritingByActivityRepresentationFromJSON(json['data']),
  }
}

export function StudentLessonWritingByActivityRepresentationBaseApiResultToJSON(
  value?: StudentLessonWritingByActivityRepresentationBaseApiResult | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    data: StudentLessonWritingByActivityRepresentationToJSON(value.data),
  }
}
